import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface YearPickerProps {
  yearsBlockStart: number;
  selectedYear: number;
  minDate?: Date;
  maxDate?: Date;
  onYearSelect: (year: number) => void;
  onBlockChange: (delta: number) => void;
}

export function YearPicker({
  yearsBlockStart,
  selectedYear,
  minDate,
  maxDate,
  onYearSelect,
  onBlockChange,
}: YearPickerProps) {
  const years = Array.from({ length: 12 }, (_, i) => yearsBlockStart + i);

  return (
    <div className="w-[280px] p-2">
      <div className="mb-3 flex items-center justify-between">
        <button
          onClick={() => onBlockChange(-12)}
          className="rounded p-1 text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-600"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="text-sm font-semibold text-dark-500">
          {yearsBlockStart} - {yearsBlockStart + 11}
        </span>
        <button
          onClick={() => onBlockChange(12)}
          className="rounded p-1 text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-600"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {years.map((year) => {
          const yearDisabled =
            (minDate && year < minDate.getFullYear()) ||
            (maxDate && year > maxDate.getFullYear());
          const isSelected = year === selectedYear;
          return (
            <button
              key={year}
              onClick={() => !yearDisabled && onYearSelect(year)}
              disabled={!!yearDisabled}
              className={cn(
                'rounded-lg px-2 py-2 text-sm transition-colors',
                yearDisabled && 'text-neutral-200 cursor-not-allowed',
                !yearDisabled && !isSelected && 'text-dark-500 hover:bg-primary-50 hover:text-primary-600',
                isSelected && !yearDisabled && 'bg-primary-500 text-white font-semibold'
              )}
            >
              {year}
            </button>
          );
        })}
      </div>
    </div>
  );
}
